import * as React from "react";

import { StyledHamburgerButton } from "./hamburger-button-component-styles";

const HamburgerButton = ({
  toggleMenu,
  isMenuOpen,
  disabled,
}: {
  toggleMenu(): void;
  isMenuOpen: boolean;
  disabled: boolean;
}) => (
  <StyledHamburgerButton
    data-testid="navigation-button"
    className="navigation-button"
    onClick={toggleMenu}
    isMenuOpen={isMenuOpen}
    disabled={disabled}
  >
    <span className="navigation-icon" />
  </StyledHamburgerButton>
);

export default HamburgerButton;
